<template>
  <div
    class="flex gap-1.5 sm:gap-2 transition-all duration-200"
    :class="[
      props.align === 'start' ? 'items-start' : 'items-center',
      props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    ]"
    @click="toggle"
  >
    <div
      class="w-4 h-4 rounded-[4px] flex items-center justify-center transition-all duration-200 flex-shrink-0 relative"
      :class="[
        computedTopClass,
        isChecked
          ? 'bg-[#d0a444] border border-[#d0a444]'
          : 'bg-white border border-gray-300',
        !props.disabled && !isChecked ? 'hover:border-[#d0a444]' : '',
      ]"
    >
      <svg
        v-if="isChecked"
        class="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div v-if="$slots.default" class="select-none">
      <slot />
    </div>
    <label
      v-else-if="label"
      class="text-xs sm:text-sm font-medium select-none"
      :class="props.disabled ? 'text-gray-400' : 'text-gray-900'"
    >
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  modelValue?: boolean;
  label?: string;
  disabled?: boolean;
  align?: "start" | "center";
  topClass?: string | false;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
  align: "center",
});

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  change: [value: boolean];
}>();

const computedTopClass = computed(() => {
  if (props.topClass === false) return "";
  return props.topClass || "top-1.5";
});

const isChecked = computed(() => props.modelValue);

const toggle = () => {
  if (props.disabled) return;
  const newValue = !props.modelValue;
  emit("update:modelValue", newValue);
  emit("change", newValue);
};
</script>
